import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.tasks.general,
        label: 'General',
        permission: PERMISSIONS.tasks.tabs.general.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.tasks.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.tasks.tabs.attachment.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.tasks.logs,
        label: 'Logs',
        permission: PERMISSIONS.tasks.tabs.logs.read,
        id: '3',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
